import React from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import groceryshop from "../images/almoune-logo-1613775290.jpg";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <div>
      <footer className="footer mt-8">
        <div className="overlay" />
        <div className="container">
          <div className="row footer-row">
            <div className="col-sm-6 col-lg-3 mb-30">
              <div className="footer-widget">
                <div className="footer-logo">
                  <Link to="/">
                    <img src={groceryshop} style={{ width: 300, padding: 20, marginLeft: "-30px" }} alt="Almoune" />
                  </Link>
                </div>
                <p className="mb-30">
                  Almoune propose une epicerie libanaise en ligne avec une selection de produits orientaux, pains, condiments, gourmandises et boissons.
                </p>
              </div>
            </div>

            <div className="col-sm-6 col-lg-3 mb-30">
              <div className="footer-widget mb-0">
                <h4>Nos rayons</h4>
                <div className="line-footer" />
                <ul className="footer-link mb-0">
                  <li><Link to="/Shop"><span><i className="fa fa-angle-right" /></span> Aliments et Laitiers</Link></li>
                  <li><Link to="/Shop"><span><i className="fa fa-angle-right" /></span> Gourmandises</Link></li>
                  <li><Link to="/Shop"><span><i className="fa fa-angle-right" /></span> Condiments</Link></li>
                  <li><Link to="/Shop"><span><i className="fa fa-angle-right" /></span> Aperitifs et pain</Link></li>
                  <li><Link to="/Shop"><span><i className="fa fa-angle-right" /></span> Boissons</Link></li>
                </ul>
              </div>
            </div>

            <div className="col-sm-6 col-lg-3 mb-30">
              <div className="footer-widget mb-0">
                <h4>Infos clients</h4>
                <div className="line-footer" />
                <ul className="footer-link mb-0">
                  <li><Link to="/Contact"><span><i className="fa fa-angle-right" /></span> Contact</Link></li>
                  <li><Link to="/Faq"><span><i className="fa fa-angle-right" /></span> FAQ</Link></li>
                  <li><Link to="/StoreList"><span><i className="fa fa-angle-right" /></span> Livraison</Link></li>
                  <li><Link to="/ShopCart"><span><i className="fa fa-angle-right" /></span> Panier</Link></li>
                  <li><Link to="/ShopCheckOut"><span><i className="fa fa-angle-right" /></span> Commander</Link></li>
                </ul>
              </div>
            </div>

            <div className="col-sm-6 col-lg-3 mb-30">
              <div className="footer-widget mb-0">
                <h4>Almoune</h4>
                <div className="line-footer" />
                <ul className="footer-link mb-0">
                  <li><Link to="/AboutUs"><span><i className="fa fa-angle-right" /></span> A propos</Link></li>
                  <li><Link to="/StoreList"><span><i className="fa fa-angle-right" /></span> Services</Link></li>
                  <li><Link to="/Coupons"><span><i className="fa fa-angle-right" /></span> Promotions</Link></li>
                  <li><Link to="/helpcenter"><span><i className="fa fa-angle-right" /></span> Aide</Link></li>
                </ul>
              </div>
              <div className="footer-widget mt-8">
                <div className="newsletter-item">
                  <input type="email" id="email" placeholder="Votre email" className="form-control form-control-lg" required />
                  <button type="submit"><i className="fa fa-paper-plane" /></button>
                </div>
                <p className="mt-3 mb-0">Telephone : +33 9 81 39 14 33</p>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bar ">
          <div className="container text-center">
            <div className="footer-copy">
              <div className="copyright">© {year} Almoune - Epicerie libanaise en ligne</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
